import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import CalendarHeatmap from './CalendarHeatmap';
import useStore from '../store';

export default function CalendarHeatmapBlur({ checkinDates, color }) {
  const navigate = useNavigate();
  const isPremium = useStore((s) => s.isPremium);
  const premium = isPremium();

  // For free users, only show last 30 days of data
  const filteredDates = useMemo(() => {
    if (premium) return checkinDates;

    const cutoff = new Date();
    cutoff.setDate(cutoff.getDate() - 30);
    const cutoffStr = cutoff.toISOString().split('T')[0];
    return (checkinDates || []).filter(d => d >= cutoffStr);
  }, [checkinDates, premium]);

  if (premium) {
    return <CalendarHeatmap checkinDates={filteredDates} color={color} />;
  }

  return (
    <div className="relative">
      <CalendarHeatmap checkinDates={filteredDates} color={color} />
      {/* Gradient blur overlay on left (older) side */}
      <div className="absolute inset-0 rounded-2xl overflow-hidden pointer-events-none">
        <div
          className="absolute inset-y-0 left-0 w-2/3"
          style={{
            background: 'linear-gradient(to right, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.7) 60%, transparent 100%)',
          }}
        />
        <div
          className="absolute inset-y-0 left-0 w-2/3 dark:block hidden"
          style={{
            background: 'linear-gradient(to right, rgba(31,41,55,0.95) 0%, rgba(31,41,55,0.7) 60%, transparent 100%)',
          }}
        />
      </div>
      {/* CTA button */}
      <div className="absolute inset-0 flex items-center justify-start pl-8 pointer-events-auto">
        <button
          onClick={() => navigate('/premium?source=calendar_blur')}
          className="px-3 py-2 bg-primary-600 hover:bg-primary-700 text-white text-xs font-medium rounded-xl shadow-lg transition-colors"
        >
          See full year with Premium
        </button>
      </div>
    </div>
  );
}
